import { defineStore } from 'pinia'
import { ref } from 'vue'
import Backend from '@/models/backend'
import { logger } from '@/models/logger'
import { syncLocaleWithPlayerFlags } from '@/locales'

export const usePlayerFlagsStore = defineStore('playerFlags', () => {
  const flags = ref<Map<string, string>>(new Map())
  const backend = new Backend()
  let localeSynced = false

  async function setFlag(key: string, value: string) {
    // Send to backend
    try {
      await backend.setPlayerFlag(key, value)
      flags.value.set(key, value)
    } catch (error) {
      logger.error('Failed to set player flag:', error)
    }
  }

  function getFlag(key: string): string | undefined {
    return flags.value.get(key)
  }

  function hasFlag(key: string): boolean {
    return flags.value.has(key)
  }

  function updateFlags(newFlags: Record<string, string>) {
    Object.entries(newFlags).forEach(([key, value]) => {
      flags.value.set(key, value)
    })

    // Sync locale with player flags on first load
    if (!localeSynced) {
      localeSynced = true
      syncLocaleWithPlayerFlags(getFlag, setFlag)
    }
  }

  function clearFlags() {
    flags.value.clear()
    localeSynced = false
  }

  return {
    flags,
    setFlag,
    getFlag,
    hasFlag,
    updateFlags,
    clearFlags
  }
})